/**
 * Buddy Group permission definitions.
 *
 * Maps role_name → allowed actions for the buddy group admin surface.
 * Role checks use role.role_name (NOT role.role_type).
 */

export type BuddyGroupAction =
  | 'view_list'
  | 'view_detail'
  | 'edit_group'
  | 'dissolve_group'
  | 'resolve_conflict'
  | 'dismiss_conflict';

export const BUDDY_GROUP_ROLE_PERMISSIONS: Record<string, BuddyGroupAction[]> = {
  admin: [
    'view_list',
    'view_detail',
    'edit_group',
    'dissolve_group',
    'resolve_conflict',
    'dismiss_conflict',
  ],
  delegate: [
    'view_list',
    'view_detail',
    'edit_group',
    'dismiss_conflict',
  ],
};

/**
 * Check whether a given role has a specific buddy-group action.
 */
export function roleHasBuddyGroupAction(
  roleName: string | undefined,
  action: BuddyGroupAction
): boolean {
  if (!roleName) return false;
  const allowed = BUDDY_GROUP_ROLE_PERMISSIONS[roleName];
  return !!allowed && allowed.includes(action);
}
